import { useSyncExternalStore } from 'react'

import fsmService from './FSMService'
import { FlowServiceType } from '../types/interface/fsm.interface'

// Replaces `useSelector(service, (state) => state.event.type)`. xstate v5 snapshots carry no
// `.event`, so `FSMService` records the event type from the actor's inspection hook; this
// re-reads it on every actor emission so consumers re-render exactly as they did on v4.
//
// The inspection callback runs before subscribers, so the value is already updated when the
// emission arrives.
const useLastEventType = (service: FlowServiceType): string | undefined =>
  useSyncExternalStore(
    (onStoreChange) => {
      const subscription = service.subscribe(onStoreChange)

      return () => subscription.unsubscribe()
    },
    () => fsmService.lastEventType
  )

export default useLastEventType
